export const canonicalCodeMap = {
  JA: 'JA',
  WJ: 'JA',
  AV: 'AV',
  TA: 'AV',
};

export const normalizeCarrierCode = code => canonicalCodeMap[code] || code;
